module.exports = __webpack_public_path__ + "assets/align-to-top-icon.fb8f342e.svg";